import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'

/**
 * Presents an {@link ents.core.quiver.Evaluation.Complete}
 */
@ngCore.Component({
  imports: [ds.input.code.Component],
  selector: 'atn-quiver-deployment-modal-evaluation-step-complete',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * {@link ents.core.quiver.Evaluation.Complete} to be presented
   */
  public readonly evaluationSg =
    ngCore.input<ents.core.quiver.Evaluation.Complete>(undefined, {
      alias: 'evaluation',
    })

  /** @see {@link state.quiver.evaluation.Feature} */
  public readonly evaluationFeature = ngCore.inject(
    state.quiver.evaluation.Feature,
  )

  /** @see {@link createToggle} */
  private readonly _toggles: Record<number, ngCore.WritableSignal<boolean>> = {}

  /**
   * Used to create toggles for showing/hiding information
   */
  public createToggle(index: number): ngCore.WritableSignal<boolean> {
    return (this._toggles[index] ??= ngCore.signal(false))
  }
}
